import { render, staticRenderFns } from "./AssignMenuPermissions.vue?vue&type=template&id=dcdf1f0a&scoped=true"
import script from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
export * from "./AssignMenuPermissions.vue?vue&type=script&lang=js"
import style0 from "./AssignMenuPermissions.vue?vue&type=style&index=0&id=dcdf1f0a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf1f0a",
  null
  
)

export default component.exports